/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CommoditiesControl } from "../controls/CommoditiesControl";
import { UnitsControl } from "../controls/UnitsControl";

import { useSubscription } from "./useSubscription";

export default function () {
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <CommoditiesControl />
        <UnitsControl />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="table" />
          <ReportRenderer componentId="line-chart" />
        </ReportGrid>
      </div>
    </>
  );
}
